// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3D_qv","approved":"Status_approved__Cldd0","rejected":"Status_rejected__3m6pl","expired":"Status_expired__1-0Ka","label":"Status_label__22Mrp"};